import * as React from "react";
import { forwardRef } from "react";
const StarRadiatingIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.894 7.394a1.185 1.185 0 0 1 2.171-.092l.04.092 1.604 4.042 4.146.349c1.105.093 1.434 1.451.69 2.119l-3.183 2.858.976 4.284a1.22 1.22 0 0 1-.448 1.246 1.17 1.17 0 0 1-1.349.056L12 20.081l-3.541 2.267a1.17 1.17 0 0 1-1.349-.056 1.22 1.22 0 0 1-.448-1.246l.975-4.284-3.183-2.858c-.744-.668-.415-2.026.69-2.119l4.146-.349 1.604-4.042zm-.277 4.766a1.195 1.195 0 0 1-1.008.755l-3.669.308 2.822 2.534c.334.3.47.758.373 1.184l-.85 3.737 3.08-1.972.074-.044c.35-.19.771-.19 1.122 0l.074.044 3.08 1.972-.85-3.737a1.226 1.226 0 0 1 .373-1.184l2.821-2.533-3.668-.308a1.196 1.196 0 0 1-1.008-.755L12 8.675l-1.383 3.485z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.096 9.711a.75.75 0 0 1 .947-.478l1.08.356a.75.75 0 1 1-.469 1.425l-1.08-.356a.75.75 0 0 1-.478-.947zm18.903-.478a.75.75 0 1 1 .469 1.425l-1.081.355a.75.75 0 1 1-.469-1.425l1.081-.356zM5.695 5.43a.75.75 0 0 1 1.061.008l.798.81a.75.75 0 1 1-1.069 1.053l-.798-.81a.75.75 0 0 1 .008-1.061zm11.592.008a.75.75 0 1 1 1.069 1.053l-.799.81a.75.75 0 0 1-1.068-1.053l.798-.81zM12 3.035a.75.75 0 0 1 .75.75v1.2a.75.75 0 1 1-1.5 0v-1.2a.75.75 0 0 1 .75-.75z"
}));
const ForwardRef = forwardRef(StarRadiatingIcon);
export default ForwardRef;